export default __webpack_public_path__ + "fb35537602e86beb241bd80b22adc3c5.png";